import React, { useState, useEffect } from "react";

// styles
import * as styles from "./ChefPortal.module.css";

const DynamicQuotes = () => {
  const [id, setId] = useState(0);

  const quotes = [
    <div className={styles.description} style={{ width: "325px" }}>
      <p>Alright Chef — knives sharp, station tight,</p>
      <p>
        and <strong>let’s sling some serious flavor today.</strong>
      </p>
      <p>Keep it hot, keep it tight, and don’t go</p>
      <p>
        down in the weeds — <span className={styles.orange}>you got this!</span>
      </p>
    </div>,

    <div className={styles.description} style={{ width: "315px" }}>
      <p>
        Let’s have some <strong>fun</strong> today, team.
      </p>
      <p>
        <strong>Cook with heart,</strong> don’t burn the{" "}
      </p>
      <p>bacon, and remember —</p>
      <p>
        <span className={styles.orange}>a happy Chef makes tastier food!</span>
      </p>
    </div>,

    <div className={styles.description} style={{ width: "315px" }}>
      <p>Remember, we’re not just making food.</p>
      <p>
        <strong>We’re putting flavor on</strong>{" "}
        <span className={styles.orange}>display</span>.
      </p>
      <p>Let’s put on a show they’ll taste!</p>
    </div>,

    <div className={styles.description} style={{ width: "285px" }}>
      <p>We’re not just feeding people —</p>
      <p>
        we’re making their day.{" "}
        <span className={styles.orange}>Let’s cook</span>
      </p>
      <p>
        <span className={styles.orange}>with heart and serve with style!</span>
      </p>
    </div>,

    <div className={styles.description} style={{ width: "315px" }}>
      <p>
        Every plate is a <strong>stage</strong> — now let’s give
      </p>

      <p>
        them{" "}
        <span className={styles.orange}>
          a standing ovation with every bite!
        </span>
      </p>
    </div>,

    <div className={styles.description} style={{ width: "255px" }}>
      <p>
        <span className={styles.orange}>Be the chef they remember —</span>
      </p>
      <p>for the taste, the show, and the</p>
      <p>moment they felt seen.</p>
    </div>,

    <div className={styles.description} style={{ width: "325px" }}>
      <p>Alright team — another day, another</p>
      <p>
        <strong>chance to make magic!</strong> Today, every plate
      </p>
      <p>we serve is more than food — it’s an</p>
      <p>invitation. An invitation for our guests to</p>
      <p>
        <span className={styles.orange}>
          smile, connect, and feel taken care of.
        </span>
      </p>
    </div>,

    <div className={styles.description} style={{ width: "265px" }}>
      <p>
        <strong>Great food</strong> brings them in,
      </p>
      <p>
        but <strong>great vibes</strong> bring them back —
      </p>
      <p>
        <span className={styles.orange}>let’s serve both!</span>
      </p>
    </div>,

    <div className={styles.description} style={{ width: "265px" }}>
      <p>
        Today, we <strong>don’t just cook</strong> —
      </p>
      <p>we create experiences!</p>
      <p>
        Every plate is a <strong>chance</strong> to show
      </p>
      <p>pride, passion, and precision.</p>
      <span className={styles.orange}>Let’s make every bite count.</span>
    </div>,
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setId((prev) => {
        if (prev === 8) {
          return 0;
        }
        return prev + 1;
      });
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return <div className={styles.quoteWrapper}>{quotes[id]}</div>;
};

export default DynamicQuotes;
